import Vue from 'vue';

export default ({ $tools }) => {
  Vue.filter('moneyWithDecimal', num => {
    const numberWithDecimal = (
      Math.round((Number.parseFloat(num) + Number.EPSILON) * 100) / 100
    ).toString();
    let decimalPart = numberWithDecimal.split('.')[1] || '00';
    if (decimalPart.length < 2) decimalPart += '0';

    return `${numberWithDecimal.split('.')[0]}.${decimalPart} ${$tools.currency.local}`;
  });
};
